// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"b18a45c2","408":"ca07a4e9","2718":"efef95a5","4320":"6b8eb120","9071":"53377746"}[chunkId] + ".chunk.css";
};